import React from 'react';

const WidgetFaq = (props) => {
  const _itemClick = (msg) => {
    props.actionProvider._clientMessage(msg);
  };
  return (
    <>
      <div className="widget-container">
        <div className="">
          <div className="widget-title">아래의 내용을 찾으셨나요?</div>
        </div>
        <div>
          <ul className="widget-content">
            <li>
              <a onClick={() => _itemClick('회원가입')}>회원가입</a>
            </li>
            <li>
              <a href="">아이디</a>
            </li>
            <li>
              <a href="">VOD 재생</a>
            </li>
            <li>
              <a href="">다운로드</a>
            </li>
            <li>
              <a href="">멤버십</a>
            </li>
            <li>
              <a href="">포인트</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="widget-time">{props.payload.writetime}</div>
    </>

    // <div className="widget-faq-div">
    //   <ul className="widget-faq-ul">
    //     <li>
    //       <a href="">회원가입</a>
    //     </li>
    //     <li>
    //       <a href="">로그인</a>
    //     </li>
    //     <li>
    //       <a href="">VOD 재생</a>
    //     </li>
    //     <li>
    //       <a href="">다운로드</a>
    //     </li>
    //     <li>
    //       <a href="">멤버십</a>
    //     </li>
    //     <li>
    //       <a href="">포인트</a>
    //     </li>
    //   </ul>
    // </div>
  );
};

export default WidgetFaq;
